<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},

  methods: {}
}
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  background: #ffff;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: inherit;
}
input,
button {
  outline: none;
  border: none;
  background: transparent;
  display: inline-block;
}
#app {
  font-family: 'PingFangSC-Regular', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  background: #fff;
}
.flex_box {
  display: flex;
}
.tabbar_hidden {
  width: 100%;
  height: 2.7rem;
}
.user_control_top_tip {
  padding-top: 30px;
  text-align: left;
  padding-left: 23px;
  font-size: 26px;
  color: #212121;
  margin-bottom: 35px;
}
.user_control_top_tip > div:last-child {
  font-size: 16px;
  color: #b5b5b5;
  margin-top: 8px;
}
.user_login_box {
  padding: 0 23px;
}
.user_login_list {
  padding: 20px 9px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
}
.icon_login_close {
  width: 16px;
  height: 16px;
}
.icon_login_eyes {
  width: 23px;
  height: 13px;
}
.user_login_input_box {
  flex: 1;
  align-items: center;
}
.icon_login_input_icon {
  width: 13px;
  height: 20px;
}
.user_login_input_box input {
  font-size: 20px;
  color: #323232;
  margin-left: 15px;
  flex: 1;
  padding-right: 15px;
}
.user_login_input_box input::-webkit-input-placeholder {
  color: #b5b5b5;
  font-size: 16px;
}
.define_login_button {
  width: 329px;
  height: 45px;
  background: linear-gradient(
    90deg,
    rgba(0, 217, 252, 1) 0%,
    rgba(0, 166, 250, 1) 100%
  );
  border-radius: 28px;
  margin-top: 37px;
  font-size: 18px;
  color: #fff;
}
.usercode_box {
  font-size: 14px;
  color: #474747;
  width: 80px;
  white-space: nowrap;
  text-align: center;
}
.home_fixed_box {
  width: 60px;
  height: 60px;
  background: #ffffff;
  box-shadow: 3px 2px 14px 0 rgba(0, 0, 0, 0.19);
  opacity: 0.87;
  position: fixed;
  right: 27px;
  bottom: 65px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  color: #000f43;
}
.home_fixed_box > img {
  width: 30px;
  margin-bottom: 2px;
}
</style>
